import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Pictogram } from "./brand/Pictogram";
import { IMG, themeBySlug } from "../data/content";

export const UseCaseCard = ({ u, large = false }) => {
  const t = themeBySlug(u.theme);
  return (
    <Link to={`/missions/${u.id.replace(/^uc-/, "")}`} data-testid={`use-case-${u.id}`} className={`group relative block overflow-hidden bg-ink text-white h-full ${large ? "min-h-[420px]" : "min-h-[360px]"}`}>
      <img src={IMG[u.image]} alt={u.title} className="absolute inset-0 h-full w-full object-cover opacity-45 group-hover:opacity-35 group-hover:scale-105 transition-[opacity,transform] duration-700" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/10" />
      <span className="absolute top-0 left-0 h-1 w-full" style={{ background: t.color }} />
      <div className="relative h-full flex flex-col p-7 lg:p-8">
        <div className="flex items-start justify-between">
          <Pictogram name={t.icon} color={t.color} size={44} />
          <ArrowUpRight className="opacity-60 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-[opacity,transform]" />
        </div>
        <div className="mt-auto pt-16">
          <span className="text-[11px] font-semibold uppercase tracking-[0.18em]" style={{ color: t.color }}>{t.name}</span>
          <h3 className={`mt-3 font-display font-extrabold leading-tight ${large ? "text-2xl lg:text-3xl" : "text-xl lg:text-2xl"}`}>{u.title}</h3>
          <p className="mt-3 text-sm text-white/70 max-w-md">{u.text}</p>
          <div className="mt-5 flex flex-wrap gap-2">
            {u.tags.map((tag) => <span key={tag} className="text-xs px-2.5 py-1 border border-white/20 text-white/80">{tag}</span>)}
          </div>
        </div>
      </div>
    </Link>
  );
};
